// unauthorized.component.ts
import { Component } from '@angular/core';

@Component({
  selector: 'app-unauthorized',
  template: '<p>You are not authorized to access this page.</p>',
})
export class UnauthorizedComponent {}
